import { Component, OnInit, OnChanges, SimpleChanges, DoCheck, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { INSTITUCIONAL_DOCUMENTO_SIGLA } from '../../../app.constants';
import { ProcorManutencaoComunicadoService } from '../../administrativo/procor-manutencao-comunicado/service/procor-manutencao-comunicado.service';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { DocumentosListaExibirModel } from '../../shared/models/documentos-lista-exibir.model';
import { DocumentosService } from '../../shared/services/documentos.service';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { AcessoLinksDocumentosService } from './service/acesso-links-documentos.service';

@Component({
  selector: 'app-acesso-links-documentos',
  templateUrl: './acesso-links-documentos.component.html',
  styleUrls: ['./acesso-links-documentos.component.css']
})
export class AcessoLinksDocumentosComponent implements OnInit {

  @BlockUI() blockUi: NgBlockUI;

  param = '/cardMenus/cardMenuInstitucional';

  cdCentrus: number;

  paginaTitulo: string;

  identificador = 1;

  page = 0;
  rows = 14;
  totalRecords = 0;

  intercalarPagincao = true;

  mensagemSemDocumentosParaExibir = '';

  documentosListaExibirModel: DocumentosListaExibirModel[] = [];

  selectedDocumentosListaExibir: DocumentosListaExibirModel;

  tituloPagina: string;


  constructor(
    private procorManutencaoComunicadoService: ProcorManutencaoComunicadoService,
    private documentosService: DocumentosService,
    private acessoLinksDocumentosService: AcessoLinksDocumentosService,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
  }



  ngOnInit() {
    this._gerenciarCodigoIndentificao();
    this.acessoLinksDocumentosService.mudouLayout.subscribe(arg => arg)
  }


  private _gerenciarCodigoIndentificao(): void {

    // console.log(StorafeUtil.recuperarSessionStorage(INSTITUCIONAL_DOCUMENTO_SIGLA));


    if (StorafeUtil.recuperarSessionStorage(INSTITUCIONAL_DOCUMENTO_SIGLA)) {

      const recuperandoObjeto = JSON.parse(StorafeUtil.recuperarSessionStorage(INSTITUCIONAL_DOCUMENTO_SIGLA));
      // console.log(recuperandoObjeto);

      this.tituloPagina = recuperandoObjeto.descricao;

      this.getObterDocumentoList(recuperandoObjeto.sigla);
    }
    // : (this.getObterComumicadoByTpComunicado());

  }

  paginacao(evento) {
    // console.log(evento);
    this.page = evento['page'];
    this.rows = evento['rows'];
    this.getObterComumicadoByTpComunicado();
  }


  async getObterDocumentoList(recuperandoObjeto) {
    this.documentosListaExibirModel = [];

    this.blockUi.start('Carregando...')
    try {

      await this.acessoLinksDocumentosService.getDocumentosLista(recuperandoObjeto)
        .then(documentosLista => {

          if (!documentosLista) {
            this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
            this.router.navigate([this.param], { skipLocationChange: true })
            return;
          }


          this.paginaTitulo = documentosLista['descricao'];
          this.totalRecords = documentosLista['listaDocumentos'].length;
          documentosLista['listaDocumentos'].map(item => {
            this.documentosListaExibirModel.push(new DocumentosListaExibirModel(item['descricao'], item['caminho'], item['tipo']))
          })




        });
    } catch (error) {
      this.mensagemSemDocumentosParaExibir = 'Sem dados para serem exibidos.'
      this.toastrService.info(error, '', { timeOut: 8000 })
    } finally {
      this.blockUi.stop();
    }

  }




  async getObterComumicadoByTpComunicado(): Promise<void> {
    this.documentosListaExibirModel = [];
    this.blockUi.start('Carregando...')
    try {

      this.getObterTipoComun();
      this.intercalarPagincao = false;
      const documentosLista = await this.procorManutencaoComunicadoService.getObterComumicadoByTpComunicado(this.identificador, this.rows, this.page);
      this.totalRecords = documentosLista['totalElements'];
      documentosLista['content'].map(item => {
        this.documentosListaExibirModel.push(new DocumentosListaExibirModel(item['dsTitComunicados'], item['dsLink'], 'site'))
      })
    } catch (error) {
      this.mensagemSemDocumentosParaExibir = 'Sem dados para serem exibidos.'
      this.toastrService.info(MessageUtil.ERROR_LISTAR_INFORMACAO, '', { timeOut: 8000 })
      console.log(error);
    } finally {
      this.blockUi.stop();
    }
  }


  async getObterTipoComun() {
    try {
      const documentosLista = await this.procorManutencaoComunicadoService.getObterTipoComun();
      const titulo = documentosLista.find(item => item.tpComunicados === Number(this.identificador));
      // this.paginaTitulo = titulo['dsComunicados'];
    } catch (error) {
      console.log(error);
    }
  }

  downloandDocument(documento: DocumentosListaExibirModel): void {

    if (documento.tipo === 'site') {
      // this.toastrService.info('Vendo ainda como resolver esse aqui ', '', { timeOut: 8000 })
      return;
    }
    if (documento.tipo === 'docLink') {
      // this.toastrService.info('Vendo ainda como resolver esse aqui ', '', { timeOut: 8000 })
      window.open(documento.caminho)
      return;
    }
    try {
      this.documentosService.downloandDocument(documento.tipo, documento.caminho);
    } catch (error) {
      console.error(error);
    }

  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/institucional/acesso-links-documentos/acesso-links-documentos.component.ts